module.exports = __webpack_public_path__ + "img/cams.8ec6917.png";